import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function EnglishFunctionalEntry() {
  return (
    <>
      <Header />
      
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk1.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Animated Pattern Overlay */}
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          
          {/* Gradient Border Bottom */}
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '5px',
            background: 'linear-gradient(90deg, #B17ACC 0%, #7B3F9E 50%, #B17ACC 100%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 3s ease-in-out infinite'
          }}></div>
          
          <div className="container" style={{ position: 'relative', zIndex: 2, padding: '80px 20px' }}>
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                {/* Animated Badge */}
                <div style={{
                  display: 'inline-block',
                  backgroundColor: 'rgba(123, 63, 158, 0.2)',
                  backdropFilter: 'blur(10px)',
                  padding: '12px 30px',
                  borderRadius: '50px',
                  marginBottom: '30px',
                  border: '2px solid rgba(123, 63, 158, 0.4)',
                  boxShadow: '0 4px 20px rgba(123, 63, 158, 0.2)'
                }}>
                  <span style={{ 
                    color: '#e0d9e4ff', 
                    fontSize: '0.9rem', 
                    fontWeight: '700', 
                    letterSpacing: '2px',
                    textShadow: '0 0 10px rgba(123, 63, 158, 0.5)'
                  }}>
                    📝 FUNCTIONAL SKILLS
                  </span>
                </div>
                
                <h1 style={{ 
                  fontSize: '4.5rem', 
                  fontWeight: '800',
                  color: 'white',
                  marginBottom: '30px',
                  lineHeight: '1.1',
                  letterSpacing: '-2px',
                  textShadow: '0 4px 30px rgba(0,0,0,0.5), 0 0 60px rgba(123, 63, 158, 0.2)'
                }}>
                  English Functional Skills Entry
                </h1>
                
                {/* Decorative Line */}
                <div style={{
                  width: '150px',
                  height: '6px',
                  background: 'linear-gradient(90deg, transparent, #B17ACC, transparent)',
                  margin: '0 auto 35px',
                  borderRadius: '10px',
                  boxShadow: '0 0 20px rgba(123, 63, 158, 0.5)'
                }}></div>
                
                <p style={{
                  fontSize: '1.4rem',
                  color: 'rgba(255,255,255,0.95)',
                  maxWidth: '700px',
                  margin: '0 auto',
                  lineHeight: '1.8',
                  textShadow: '0 2px 15px rgba(0,0,0,0.3)',
                  fontWeight: '300'
                }}>
                  Entry Level 1, 2, 3 - Develop your English skills
                </p>
              </div>
            </div>
          </div>
          
          <style>{`
            @keyframes float {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-20px); }
            }
            @keyframes shimmer {
              0% { background-position: 200% 0; }
              100% { background-position: -200% 0; }
            }
          `}</style>
        </section>

        {/* Content Section */}
        <section id="english-functional-entry" className="section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            
            <div className="row justify-content-center">
              <div className="col-lg-10">
                
                {/* Overview */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h2 style={{ 
                    fontSize: '2.5rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '2rem' }}>📖</span> Overview
                  </h2>
                  <div style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                    <p style={{ 
                      backgroundColor: '#fef3c7', 
                      padding: '15px 20px', 
                      borderRadius: '12px',
                      borderLeft: '4px solid #f59e0b',
                      fontWeight: '600',
                      color: '#92400e'
                    }}>
                      You must be aged 19+ at 31 August of the current academic year.
                    </p>
                    <h4 style={{ fontSize: '1.3rem', fontWeight: '600', color: '#7B3F9E', marginTop: '25px', marginBottom: '15px' }}>
                      About this qualification:
                    </h4>
                    <p>
                      The purpose of Functional Skills English Entry Level qualifications is to demonstrate the ability at an appropriate level to read, write, speak, listen, and communicate in English, and to apply this knowledge and these skills in familiar situations.
                    </p>
                    <h4 style={{ fontSize: '1.3rem', fontWeight: '600', color: '#7B3F9E', marginTop: '25px', marginBottom: '15px' }}>
                      Who is it suitable for?
                    </h4>
                    <p>
                      Functional Skills qualifications in English at Entry Level are ideal for learners wishing to develop practical, transferable skills in English to work confidently, effectively, and independently in life. It is suitable for a wide range of individuals and is fundamental to the successful completion of various wider qualifications and frameworks, such as Foundation Learning.
                    </p>
                    <p style={{ marginBottom: 0 }}>
                      Functional Skills English qualifications enable learners to develop confidence and fluency in, and a positive attitude towards, English. Learners will be able to competently use English in the real world and gain a sound grasp of basic English knowledge and skills. They also help learners progress into employment or further technical education and develop skills for everyday life. They are suitable for a range of learners and are fundamental for completing various qualifications and frameworks, such as Foundation Learning.
                    </p>
                  </div>
                </div>

                {/* Entry Requirements */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <div style={{
                    backgroundColor: '#7b5ba1',
                    color: 'white',
                    padding: '25px',
                    textAlign: 'center',
                    marginLeft: '-40px',
                    marginRight: '-40px',
                    marginTop: '-40px',
                    marginBottom: '25px'
                  }}>
                    <h4 style={{ 
                      fontSize: '1.5rem', 
                      fontWeight: '700', 
                      marginBottom: 0 
                    }}>
                      Entry Requirements
                    </h4>
                  </div>
                  <p style={{
                    color: '#475569',
                    fontSize: '1.05rem',
                    lineHeight: '1.6',
                    marginBottom: 0
                  }}>
                    There are no pre-entry requirements for this qualification and no minimum age requirement has been set for registration.
                  </p>
                </div>

                {/* Qualification Structure */}
                <div className="mb-5 p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>📝</span> Qualification Structure
                  </h3>
                  <p style={{ fontSize: '1.05rem', color: '#475569', marginBottom: '20px' }}>
                    These qualifications are assessed via 3 controlled assessments which cover:
                  </p>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <div style={{
                        backgroundColor: '#eff6ff',
                        padding: '25px',
                        borderRadius: '12px',
                        border: '2px solid #3b82f6',
                        textAlign: 'center'
                      }}>
                        <div style={{ fontSize: '3rem', marginBottom: '10px' }}>📚</div>
                        <div style={{ fontSize: '1.2rem', fontWeight: '700', color: '#1e40af', marginBottom: '8px' }}>
                          Reading
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div style={{
                        backgroundColor: '#F5EBFA',
                        padding: '25px',
                        borderRadius: '12px',
                        border: '2px solid #B17ACC',
                        textAlign: 'center'
                      }}>
                        <div style={{ fontSize: '3rem', marginBottom: '10px' }}>✍️</div>
                        <div style={{ fontSize: '1.2rem', fontWeight: '700', color: '#7B3F9E', marginBottom: '8px' }}>
                          Writing
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div style={{
                        backgroundColor: '#fef3c7',
                        padding: '25px',
                        borderRadius: '12px',
                        border: '2px solid #f59e0b',
                        textAlign: 'center'
                      }}>
                        <div style={{ fontSize: '3rem', marginBottom: '10px' }}>💬</div>
                        <div style={{ fontSize: '1.2rem', fontWeight: '700', color: '#92400e', marginBottom: '8px' }}>
                          Speaking, Listening<br/>& Communicating
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Attendance Requirements */}
                <div className="shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    backgroundColor: '#7b5ba1',
                    color: 'white',
                    padding: '25px',
                    textAlign: 'center'
                  }}>
                    <h4 style={{ 
                      fontSize: '1.5rem', 
                      fontWeight: '700', 
                      marginBottom: 0 
                    }}>
                      Attendance Requirements
                    </h4>
                  </div>
                  <div style={{
                    padding: '25px',
                    backgroundColor: '#f8fafc'
                  }}>
                    <div style={{ marginBottom: '15px', paddingBottom: '15px', borderBottom: '1px solid #e2e8f0' }}>
                      <div style={{ color: '#1e293b', fontSize: '1rem', fontWeight: '600', marginBottom: '5px' }}>📅 Course Duration</div>
                      <div style={{ color: '#475569', fontSize: '0.95rem' }}>The course runs throughout a year.</div>
                    </div>
                    <div style={{ marginBottom: '15px', paddingBottom: '15px', borderBottom: '1px solid #e2e8f0' }}>
                      <div style={{ color: '#1e293b', fontSize: '1rem', fontWeight: '600', marginBottom: '5px' }}>🕒 Class Schedule</div>
                      <div style={{ color: '#475569', fontSize: '0.95rem' }}>2 hours classes Monday-Thursday</div>
                      <div style={{ color: '#475569', fontSize: '0.95rem' }}>10AM or 6PM</div>
                    </div>
                    <div style={{ marginBottom: '15px', paddingBottom: '15px', borderBottom: '1px solid #e2e8f0' }}>
                      <div style={{ color: '#1e293b', fontSize: '1rem', fontWeight: '600', marginBottom: '5px' }}>📈 Pass Rates</div>
                      <div style={{ color: '#475569', fontSize: '0.95rem' }}>Excellent, above national average</div>
                    </div>
                    <div style={{ marginBottom: '15px', paddingBottom: '15px', borderBottom: '1px solid #e2e8f0' }}>
                      <div style={{ color: '#1e293b', fontSize: '1rem', fontWeight: '600', marginBottom: '5px' }}>👨‍🏫 Teaching Quality</div>
                      <div style={{ color: '#475569', fontSize: '0.95rem' }}>Excellent teaching and support from outstanding staff</div>
                    </div>
                    <div style={{ marginBottom: '15px', paddingBottom: '15px', borderBottom: '1px solid #e2e8f0' }}>
                      <div style={{ color: '#1e293b', fontSize: '1rem', fontWeight: '600', marginBottom: '5px' }}>📊 Course Levels</div>
                      <div style={{ color: '#475569', fontSize: '0.95rem' }}>The course is offered at three different levels so there is something for everybody</div>
                    </div>
                    <div>
                      <div style={{ color: '#1e293b', fontSize: '1rem', fontWeight: '600', marginBottom: '5px' }}>🚀 Progression</div>
                      <div style={{ color: '#475569', fontSize: '0.95rem' }}>On completion of the course, learners can progress to higher classes, apprenticeships</div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default EnglishFunctionalEntry;
